import { motion } from "framer-motion";
import { Cross, Hotel, ClipboardCheck, ShieldCheck } from "lucide-react";

const USES = [
  { icon: Cross, color: "#10B981", title: "Farmacie", desc: "Punto di accesso e supporto territoriale." },
  { icon: Hotel, color: "#FF8A5B", title: "Hotel", desc: "Assistenza sanitaria per ospiti italiani e internazionali." },
  { icon: ClipboardCheck, color: "#3B82F6", title: "Post-dimissione", desc: "Controlli dopo il ritorno a domicilio." },
  { icon: ShieldCheck, color: "#8B5CF6", title: "Aziende e assicurazioni", desc: "Servizio integrabile nel welfare sanitario." },
];

export default function OtherUsesSection() {
  return (
    <section id="altri-utilizzi" className="bg-white py-20 sm:py-28" data-testid="other-uses-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#F6F4FA] px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#5B2C91]">
            <span className="h-2 w-2 rounded-full bg-[#D4F84A]" />
            Altri utilizzi
          </span>
          <motion.h2
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="font-heading mt-5 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#1F152E]"
            data-testid="other-uses-title"
          >
            Un servizio che si adatta a più contesti
          </motion.h2>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10 overflow-hidden rounded-[2rem] lg:rounded-[2.5rem] shadow-[0_30px_80px_rgba(91,44,145,0.18)] ring-1 ring-white/60"
        >
          <img
            src="/generated/altri-utilizzi.png"
            alt="Professionisti di diversi contesti: farmacista, responsabile di hotel e operatore in cantiere/azienda"
            width={1644}
            height={941}
            className="w-full h-auto object-contain"
            data-testid="other-uses-image"
          />
        </motion.div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {USES.map((u, i) => {
            const Icon = u.icon;
            return (
              <motion.div
                key={u.title}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.07, ease: [0.16, 1, 0.3, 1] }}
                className="rounded-3xl bg-white p-6 ring-1 ring-[#5B2C91]/8 shadow-[0_8px_30px_rgb(91,44,145,0.05)] transition-transform duration-300 hover:-translate-y-1.5"
                data-testid="other-use-card"
              >
                <span
                  className="inline-flex h-12 w-12 items-center justify-center rounded-2xl"
                  style={{ backgroundColor: `${u.color}18`, color: u.color }}
                >
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="font-heading mt-5 text-lg font-semibold text-[#1F152E]">{u.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#6B6280]">{u.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
